import I18N from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationsAr from './locales/ar/translation.json';
import translationsCn from './locales/cn/translation.json';
import translationsDe from './locales/de/translation.json';
import translationsEn from './locales/en/translation.json';
import translationsEs from './locales/es/translation.json';
import translationsFr from './locales/fr/translation.json';
import translationsId from './locales/id/translation.json';
import translationsPt from './locales/pt/translation.json';
import translationsRu from './locales/ru/translation.json';
import translationsTr from './locales/tr/translation.json';
import translationsVi from './locales/vi/translation.json';

interface I18nType {
  t: (key: string, options?: Record<string, unknown>) => any;
  exists: any;
  changeLanguage: (lang: string) => Promise<void>;
}

export const i18n: I18nType = I18N as any;
const savedLang = localStorage.getItem('lang') || 'en';
document.documentElement.lang = savedLang;

export const changeLanguage = (lng: string) => {
  if (savedLang === lng) return;

  i18n.changeLanguage(lng);
  localStorage.setItem('lang', lng);
  window.location.reload();
};

I18N.use(initReactI18next).init({
  lng: savedLang,
  fallbackLng: 'en',
  showSupportNotice: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    ar: {
      translation: translationsAr,
    },
    cn: {
      translation: translationsCn,
    },
    de: {
      translation: translationsDe,
    },
    en: {
      translation: translationsEn,
    },
    es: {
      translation: translationsEs,
    },
    fr: {
      translation: translationsFr,
    },
    id: {
      translation: translationsId,
    },
    pt: {
      translation: translationsPt,
    },
    ru: {
      translation: translationsRu,
    },
    tr: {
      translation: translationsTr,
    },
    vi: {
      translation: translationsVi,
    },
  },
  parseMissingKeyHandler: (key, _, props) => {
    if (props.count > 1) {
      key = `${key}_other`;
    } else {
      key = `${key}_one`;
    }

    const result = i18n.exists(key) ? i18n.t(key, props) : key;
    return result;
  },
});
